import { Gender } from 'src/models/applicant/resume/blocks/position/types';

export const hasGender = (gender: Gender): boolean => gender === Gender.Male || gender === Gender.Female;
export const getAvatarLetters = (lastName: string, firstName: string): string => `${lastName[0]}${firstName[0]}`;
